import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { DeleteDialog } from '@app/components/dialog';
import { useDialog, useRequestState } from '@app/hooks';
import { AddRoleDialog } from './add-role/add-role-dialog';
import { IRole } from '../types';
import { selectRoleStatusUpdateState } from '../selectors';
import { updateRoleStatus } from '../slice';

interface Props {
  rows: IRole;
}

const RowActions = ({ rows }: Props) => {
  const menuPopover = useMenuPopover();
  const activeInactiveDialog = useDialog();
  const editDialog = useDialog();

  const actions = [
    {
      label: Strings.rowActions.edit,
      callback: editDialog.show,
    },
    {
      label: Strings.common.activeInactiveTitle(rows.active),
      callback: activeInactiveDialog.show,
    },
  ];
  const dispatch = useDispatch();

  const { loading } = useRequestState({
    stateSelector: selectRoleStatusUpdateState,
    successMessageShown: true,
    onSuccess: activeInactiveDialog.hide,
    errorShown: true,
  });

  const updateRoleStatusHandle = () => {
    dispatch(
      updateRoleStatus({
        row: rows,
      })
    );
  };

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>

      <DeleteDialog
        title={`${Strings.common.activeInactiveTitle(rows.active)}  ${Strings.role.role}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.activeInactiveCaption(rows.active, Strings.role.role)}
        loading={loading}
        visible={activeInactiveDialog.visible}
        onClickDelete={updateRoleStatusHandle}
        onClose={activeInactiveDialog.hide}
      />

      {editDialog.visible && <AddRoleDialog open onClose={editDialog.hide} row={rows} />}
    </>
  );
};

export { RowActions };
